import { RIDE_STATUSES, TERM_REASONS } from "score-common";

// #3399 -- which term reason a ride row's red chip shows, or null when the row
// is not a terminated ride (GLOSSARY.md: Term reason, Terminated ride).
//
// `row.termReason` is already resolved by orderOfGo.js's buildRideRow through
// score-common (deriveRideOutcomeLabel -> deriveRideTermReason over the ride's
// authoritative sheets), so a COMPLETED ride eliminated on its sheet carries
// "Eliminated" here. Only the five TERM_REASONS earn a chip: the "No score
// recorded" label is a different thing (not a terminated ride) and stays text.
// A ride whose status is SCRATCHED with no stored reason falls back to
// Scratched, the same collapse resolveDisplayTermReason makes. `alsoScratched`
// lets a caller fold in a second scratched signal (the lookup list's
// entry.scratched also reads the result side).
const TERM_REASON_VALUES = new Set(Object.values(TERM_REASONS));

export function termChipReason(row, alsoScratched = false) {
  if (!row) return null;
  if (TERM_REASON_VALUES.has(row.termReason)) return row.termReason;
  if (alsoScratched || row.status === RIDE_STATUSES.SCRATCHED) return TERM_REASONS.SCRATCHED;
  return null;
}

// Static i18n keys only (no t(`...${reason}`)). Scratched and Eliminated already
// have announcer keys; the other three use common-fe's English defaults, the
// same words the rows printed before (row.termReason was rendered raw).
export function termChipLabels(t) {
  return {
    [TERM_REASONS.SCRATCHED]: t("oog.scratched"),
    [TERM_REASONS.ELIMINATED]: t("liveDesk.eliminated"),
  };
}
